import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { UserStateContext } from './user-state-context';
import { getNotificationLogNewCount } from 'shared/common.api';
export const NotificationsContext = createContext();

/**
 * Holds the unread-notification count for the header badge so it can be updated
 * from anywhere (e.g. when a notification is marked read on the notifications
 * page). Scoped to the active company.
 */
export const NotificationsContextProvider = ({
  children
}) => {
  const {
    user,
    asCompany
  } = useContext(UserStateContext);
  const [newCount, setNewCount] = useState(0);
  const refreshNewCount = useCallback(() => {
    if (!user?.id || !asCompany?.id) {
      return;
    }
    getNotificationLogNewCount({
      company: asCompany.id
    }).then(({
      data
    }) => setNewCount(data.count)).catch(() => {});
  }, [user?.id, asCompany?.id]);
  useEffect(() => {
    refreshNewCount();
  }, [refreshNewCount]);
  const decrementNewCount = useCallback((amount = 1) => {
    setNewCount(current => Math.max(0, current - amount));
  }, []);
  return <NotificationsContext.Provider value={{
    newCount,
    setNewCount,
    refreshNewCount,
    decrementNewCount
  }}>
      {children}
    </NotificationsContext.Provider>;
};